module.exports = __webpack_public_path__ + "img/loading-spinner.870f22d0.svg";